import { render, staticRenderFns } from "./DFileUploadPreview.vue?vue&type=template&id=1fcf08ae&"
import script from "./DFileUploadPreview.vue?vue&type=script&lang=js&"
export * from "./DFileUploadPreview.vue?vue&type=script&lang=js&"
import style0 from "./DFileUploadPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports